module.exports = __webpack_public_path__ + "img/bowling-ball.12cc6563.svg";